import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Select from 'react-select';
import InputMask from 'react-input-mask';
import config from '../../config';

import {
    getDriverProfile,
    updateInput,
    updateInputCv,
    submitDriverProfile,
    loadCitySelectOptions,
} from '../../actions/driver_profile_actions';

class DriverProfile extends Component {

    constructor(props) {
        super(props);

        this.state = {
            success: '',
            errors: [],
            loaded: false,
            button: '',
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInput = this.handleInput.bind(this);
        this.handleFileCvChange = this.handleFileCvChange.bind(this);
        this.removeFileCv = this.removeFileCv.bind(this);
    }

    componentDidMount() {
        this.props.getDriverProfile();
    }

    componentWillReceiveProps(nextProps) {
        if(!this.state.loaded) {
            this.props.loadCitySelectOptions(nextProps.driverProfile.city);
        }

        this.setState({
            loaded: true,
        });
    }

    handleSubmit(event) {
        const driver = this.props.driverProfile;
        const {name, lastName, age, city, telephoneNumber, licenceFromYear, lifetimeKm, hasOwnCar, knowBratislava, criminalRecord, contractType, fbLink, uberExperience} = driver;
        const array = [
            name,
            lastName,
            age,
            city,
            telephoneNumber,
            licenceFromYear,
            lifetimeKm,
            hasOwnCar,
            knowBratislava,
            criminalRecord,
            contractType,
            fbLink,
            uberExperience,
        ];

        let errors = [];
        const errorMessages = [
            'Vyplň meno!',
            'Vyplň priezvisko!',
            'Vyplň vek!',
            'Vyber kde máš trvalý pobyt - mesto (obec)!',
            'Vyplň telefóne číslo!',
            'Vyber koľko rokov máš vodičský preukaz!',
            'Vyber koľko km si doteraz najazdil!',
            'Vyber či máš auto!',
            'Vyber či poznáš Bratislavu!',
            'Máš čístý register?',
            'Vyber typ spolupráce!',
            'Zadaj adresu na tvoj facebook profil!',
            'Vyber skúsenosti s Uberom!',
        ];

        const valid = array.every((data, index) => {
            let valid = true;

            if(data === null || data === '' || data === undefined) {
                valid = false;
                errors.push({
                    message: errorMessages[index]
                });
            }

            if(index === 4) {
                const regex = /^\+421 ?([0-9]{3}) ?([0-9]{3}) ?([0-9]{3})$/;
                if(!regex.test(data)) {
                    errors.push({
                        message: "Oprav tel. číslo!"
                    });
                    valid = false;
                }
            }


            return valid;
        });

        this.setState({
            errors,
        });

        const button = event.target;
        setTimeout(() => {
            button.className = 'btn btn-lg btn-primary';
        }, config.buttonTimeout);

        if(!valid) {
            button.className = 'btn btn-lg btn-danger';

            return;
        }

        button.className = 'btn btn-lg btn-success';
        this.setState({
            success: "Profil bol úspešne uložený",
        });

        console.log("saving");
        console.log(driver);

        this.props.submitDriverProfile(driver);
    }

    handleInput(event) {
        const name = event.target.name;
        const data = event.target.value;
        this.props.updateInput(data, name);
    }

    handleSelectInput(name, event) {
        const data = event.value;
        this.props.updateInput(data, name);
    }

    handleFileCvChange(event) {
        event.preventDefault();

        const reader = new FileReader();
        const file = event.target.files[0];

        let extension;
        switch (file.type) {
            case "application/pdf":
                extension = "pdf";
                break;
            case "application/msword":
                extension = "doc";
                break;
            case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
                extension = "docx";
                break;
            default:
                this.setState({
                    errors: [ { "message": "Životopís musí byť vo formáte pdf/doc/docx." } ]
                });

                setTimeout(() => {
                    console.log("timeout");
                    this.setState({errors: []})
                }, config.errorTimeout);
                return;
        }

        reader.onloadend = () => {
            this.props.updateInputCv(reader.result, extension);
        };

        reader.readAsDataURL(file);
    }

    removeFileCv() {
        this.props.updateInputCv(null, null);
    }

    alertTimeout() {
        if (this.state.success)
            setTimeout(() => {
                this.setState({success: ''})
            }, config.successTimeout);

        if (this.state.errors.length > 0)
            setTimeout(() => {
                this.setState({errors: []})
            }, config.errorTimeout);
    }

    render() {
        let licenceYears = [];
        for (let i = 2017; i > 1985; i--)
            licenceYears.push({value: i, label: i});

        licenceYears.push({
            value: 1900,
            label: "skôr ako 1985"
        });

        const kmRanges = [
            {
                value: 0,
                label: "menej ako 100 km"
            },
            {
                value: 100,
                label: "100-1000 km"
            },
            {
                value: 1000,
                label: "1000-3000 km"
            },
            {
                value: 3000,
                label: "3000-5000 km"
            },
            {
                value: 5000,
                label: "5000-10 000 km"
            },
            {
                value: 10000,
                label: "10 000- 20 000 km"
            },
            {
                value: 20000,
                label: "viac ako 20 000 km"
            },
        ];

        let ageOptions = [];
        for(let i=18; i<=60; i++)
            ageOptions.push({
                value: i,
                label: i,
            });

        ageOptions.push({
            value: 100,
            label: "viac ako 60",
        });

        const driver = this.props.driverProfile;

        this.alertTimeout();

        if(!this.state.loaded)
            return <div className="alert alert-info">Načítam...</div>;

        return (
            <div className="panel panel-default">
                <div className="panel-heading">
                    <h3 className="panel-title">Moje údaje</h3>
                </div>
                <div className="panel-body">
                    {this.state.success && (
                        <div className="alert alert-success">{this.state.success}</div>
                    )}
                    {(this.state.errors.length > 0) && (
                        <div className="alert alert-danger">{this.state.errors[0].message}</div>
                    )}
                    <form>
                        <div className="form-group">
                            <label className="control-label">Meno</label>
                            <input
                                type="text"
                                name="name"
                                value={driver.name}
                                onChange={this.handleInput}
                                className="form-control"/>
                        </div>
                        <div className="form-group">
                            <label className="control-label">Priezvisko </label>
                            <input
                                type="text"
                                name="lastName"
                                value={driver.lastName}
                                onChange={this.handleInput}
                                className="form-control"/>
                        </div>
                        <div className="form-group">
                            <label className="control-label">Vek </label>
                            <Select
                                placeholder="Vyber..."
                                searchable={true}
                                clearable={false}
                                value={driver.age}
                                options={ageOptions}
                                onChange={this.handleSelectInput.bind(this, 'age')}
                            />
                        </div>
                        <div className="form-group">
                            <label className="control-label">Trvalý pobyt mám v meste (obci) </label>
                            <Select
                                ignoreCase={true}
                                placeholder="Zadaj..."
                                searchable={true}
                                clearable={false}
                                value={driver.city}
                                options={this.props.cityOptions}
                                onChange={this.handleSelectInput.bind(this, 'city')}
                                onInputChange={(input) => {
                                    if(!input)
                                        input = driver.city;

                                    this.props.loadCitySelectOptions(input);
                                }}
                            />
                        </div>
                        <div className="form-group">
                            <label className="control-label">Telefónne číslo </label>
                            <InputMask
                                name="telephoneNumber"
                                type="tel"
                                mask="+421 999 999 999"
                                value={driver.telephoneNumber}
                                className="form-control"
                                onChange={this.handleInput}
                            />
                        </div>
                        <div className="form-group">
                            <label className="control-label">Vodičský preukaz máš od roku: </label>
                            <Select
                                placeholder="Vyber..."
                                searchable={true}
                                clearable={false}
                                value={driver.licenceFromYear}
                                options={licenceYears}
                                onChange={this.handleSelectInput.bind(this, 'licenceFromYear')}
                            />
                        </div>
                        <div className="form-group">
                            <label className="control-label">Koľko km si doteraz najazdil?</label>
                            <Select
                                placeholder="Vyber..."
                                searchable={false}
                                clearable={false}
                                value={driver.lifetimeKm}
                                options={kmRanges}
                                onChange={this.handleSelectInput.bind(this, 'lifetimeKm')}
                            />
                        </div>
                        <div className="form-group">
                            <label className="control-label">Chceš jazdiť na svojom vlastnom aute?</label>
                            <Select
                                placeholder="Vyber..."
                                searchable={false}
                                clearable={false}
                                value={driver.hasOwnCar}
                                options={[
                                    {
                                        value: true,
                                        label: "Áno",
                                    },
                                    {
                                        value: false,
                                        label: "Nie",
                                    }
                                ]}
                                onChange={(event) => {
                                    const data = event.value;
                                    this.props.updateInput(data, 'hasOwnCar');
                                }}
                            />
                        </div>
                        <div className="form-group">
                            <label className="control-label">Poznáš Bratislavu ?</label>
                            <Select
                                placeholder="Vyber..."
                                searchable={false}
                                clearable={false}
                                value={driver.knowBratislava}
                                options={[
                                    {
                                        value: "yes",
                                        label: "Áno"
                                    },
                                    {
                                        value: "maybe",
                                        label: "Skôr áno ako nie"
                                    },
                                    {
                                        value: "no",
                                        label: "Nie"
                                    },
                                ]}
                                onChange={this.handleSelectInput.bind(this, 'knowBratislava')}
                            />
                        </div>
                        <div className="form-group">
                            <label className="control-label">Máš čistý register trestov ?</label>
                            <Select
                                placeholder="Vyber..."
                                searchable={false}
                                clearable={false}
                                value={driver.criminalRecord}
                                options={[
                                    {
                                        value: false,
                                        label: "Nie"
                                    },
                                    {
                                        value: true,
                                        label: "Áno"
                                    }
                                ]}
                                onChange={this.handleSelectInput.bind(this, 'criminalRecord')}
                            />
                        </div>
                        <div className="form-group">
                            <label className="control-label">Typ spolupráce</label>
                            <Select
                                placeholder="Vyber..."
                                searchable={false}
                                clearable={false}
                                value={driver.contractType}
                                options={[
                                    {
                                        value: "part-time",
                                        label: "Čiastočný úväzok - 80h"
                                    },
                                    {
                                        value: "part-time-student",
                                        label: "Čiastočný úväzok (študent) - 80h",
                                    },
                                    {
                                        value: "full-time",
                                        label: "Plný úväzok - 160h"
                                    }
                                ]}
                                onChange={this.handleSelectInput.bind(this, 'contractType')}
                            />
                        </div>
                        <div className="form-group">
                            <label className="control-label">Adresa na Facebook profil</label>
                            <input
                                type="text"
                                name="fbLink"
                                value={driver.fbLink}
                                onChange={this.handleInput}
                                className="form-control"
                            />
                        </div>
                        <div className="form-group">
                            <label className="control-label">Máš skúsenosti s Uberom?</label>
                            <Select
                                placeholder="Vyber..."
                                searchable={false}
                                clearable={false}
                                value={driver.uberExperience}
                                options={[
                                    {
                                        value: 0,
                                        label: "Nie, vôbec"
                                    },
                                    {
                                        value: 10,
                                        label: "Áno, do 10 jázd"
                                    },
                                    {
                                        value: 200,
                                        label: "Áno, do 200 jázd"
                                    },
                                    {
                                        value: 201,
                                        label: "Áno, viac ako 200 jázd"
                                    },
                                ]}
                                onChange={this.handleSelectInput.bind(this, 'uberExperience')}
                            />
                        </div>
                        {
                            (!driver.cv || !driver.cv.url) &&
                            <div className="form-group">
                                <label className="control-label">Životopis</label>
                                <div className="row">
                                    <div className="col-md-12">
                                        <label className="btn btn-default">
                                            Nahrať CV
                                            <input
                                                type="file"
                                                onChange={this.handleFileCvChange}
                                                style={{display: "none"}}
                                            />
                                        </label>
                                    </div>
                                </div>
                            </div>
                        }
                        {
                            driver.cv && driver.cv.url &&
                            <div className="form-group">
                                <label className="control-label">Životopis</label>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="btn-group">
                                            <button
                                                className="btn btn-danger"
                                                type="button"
                                                onClick={this.removeFileCv}
                                            >
                                                odstrániť CV
                                            </button>
                                            <a
                                                className="btn btn-default"
                                                href={driver.cv.url}
                                                target="_blank"
                                                download={`Životopis.${driver.cv.extension}`}
                                            >
                                                Stiahnuť
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </form>
                    {this.state.success && (
                        <div className="alert alert-success">{this.state.success}</div>
                    )}
                    {(this.state.errors.length > 0) && (
                        <div className="alert alert-danger">{this.state.errors[0].message}</div>
                    )}
                </div>
                <div className="panel-footer">
                    <button
                        onClick={this.handleSubmit}
                        className='btn btn-lg btn-primary'
                    >
                        Uložiť moje údaje
                    </button>
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getDriverProfile,
        updateInput,
        updateInputCv,
        submitDriverProfile,
        loadCitySelectOptions,
    }, dispatch);
}

function mapStateToProps({ driverProfile, cityOptions }) {
    return { driverProfile, cityOptions };
}

export default connect(mapStateToProps, mapDispatchToProps)(DriverProfile);



// WEBPACK FOOTER //
// ./src/app/components/driver/profile.jsx